import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  Branch,
  CreateBranch,
  FindMany,
  FindOne,
  Organisation,
  PaginateResult,
  UpdateBranch,
} from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/organisation';
  }

  create(organisationID: string, branch: CreateBranch) {
    return this.http.post<Branch>(
      `${this.baseUrl}/${organisationID}/branch`,
      branch
    );
  }

  find(
    organisationID: string,
    query: FindMany = {}
  ): Observable<PaginateResult<Branch>> {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<Branch>>(
      `${this.baseUrl}/${organisationID}/branch`,
      { params }
    );
  }

  findOne(organisationId: string, branch: string, query?: FindOne) {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<Branch>(
      `${this.baseUrl}/${organisationId}/branch/${branch}`,
      {
        params,
      }
    );
  }

  update(organisationId: string, branchId: string, branch: UpdateBranch) {
    return this.http.patch<Branch>(
      `${this.baseUrl}/${organisationId}/branch/${branchId}`,
      branch
    );
  }

  delete(organisationId: string, branchId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${organisationId}/branch/${branchId}`
    );
  }

  autoComplete =
    (organisation: string | Organisation) =>
    (search: string, page?: number) => {
      const organisationId =
        typeof organisation === 'string' ? organisation : organisation._id;
      return this.http
        .get<PaginateResult<Branch>>(
          `${this.baseUrl}/${organisationId}/branch`,
          {
            params: ObjectUtil.removeEmptyProperties({
              search,
              page,
              select: ['name'],
            }),
          }
        )
        .pipe(
          map((res) => {
            const options = res.docs.map((c) => ({
              label: c.name,
              value: c._id,
            }));
            return { options, nextPage: res.nextPage };
          })
        );
    };
}
